
import { I18nProvider } from "lib-core"

export { I18nProvider }

export default I18nProvider
